import API_BASE_URL from "../config";

export async function authFetch(url, options = {}) {
  if (!options.headers) options.headers = {};

  // Include access token if exists
  if (window.accessToken) {
    options.headers["Authorization"] = "Bearer " + window.accessToken;
  }

  options.credentials = "include"; // ALWAYS send cookies

  let res = await fetch(url, options);

  // If 401 → token expired → refresh
  if (res.status === 401) {
    const refreshed = await refreshAccessToken();
    if (refreshed) {
      options.headers["Authorization"] = "Bearer " + window.accessToken;
      res = await fetch(url, options); // retry request
    }
  }

  return res;
}

async function refreshAccessToken() {
  try {
    const res = await fetch(`${API_BASE_URL}/refresh`, {
      method: "POST",
      credentials: "include", // send refresh_token cookie
    });

    if (!res.ok) return false;

    const data = await res.json();

    window.accessToken = data.access_token; // update memory token
    return true;
  } catch (err) {
    return false;
  }
}
